import type { TeamMember } from "./types";

// Display name for a member row: full name → email → caller-supplied fallback.
// Shared by MembersTable (the rendered cell) and the CSV export so the two
// never drift.
export function memberDisplayName(member: TeamMember, fallback: string): string {
  const full = [member.firstName, member.lastName].filter(Boolean).join(" ").trim();
  return full || member.email || fallback;
}
